import React, { useEffect, useRef, useState } from "react";
import Input from "../../components/Input/Input";
import styles from "../Pages.module.css";
import Button from "../../components/Button/Button";
import { baseURL } from "../../components/utils/utils";
import { useFetch } from "../../hooks/useFetch";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const Registrar = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { setError, loading, httpRequest } = useFetch(
    `${baseURL}/apontamentos/`
  );
  const { httpGet: httpUsers } = useFetch(`${baseURL}/usuarios/`);
  const { httpGet: httpItens } = useFetch(`${baseURL}/itens/`);
  const { httpRequest: httpValor } = useFetch(`${baseURL}/valores/`);

  const [formError, setFormError] = useState("");
  const [isActive, setActive] = useState(false);
  const [dataError, setDataError] = useState("");
  const [datAtuError, setDatAtuError] = useState("");
  const [horasError, setHorasError] = useState("");
  const [obsHasError, setObsHasError] = useState("");

  const { user } = useAuthContext();

  const datRef = useRef();
  const obsRef = useRef();
  const horRef = useRef();
  const datAtuRef = useRef();

  const [UsuNome, setUsuNome] = useState("");

  const [ItemDes, setItemDes] = useState("");

  const [apontamento, setApontamento] = useState([]);
  const [ApoId, setId] = useState(0);
  const [fk_UsuId, setUsuId] = useState(0);
  const [fk_ItemId, setItemId] = useState(0);
  // const [fk_ValId, setValId] = useState(0);
  const [ApoData, setApoData] = useState(0);
  const [ApoDatAtu, setApoDatAtu] = useState(0);
  const [ApoQtdHoras, setHoras] = useState(0);
  const [ApoStatus, setStatus] = useState(1);
  const [ApoObs, setObs] = useState("");

  useEffect(() => {
    const getList = async () => {
      if (user.token) {
        setApoData(getTodayDate());
        setApoDatAtu(getTodayDate());

        if (id) {
          setItemId(id);
        }

        const nItem = await httpItens(user.token, `listar/${id}`);
        nItem && setItemDes(nItem[0].ItemDes);
        if (nItem && nItem[0].fk_UsuId) {
          const usuId = nItem[0].fk_UsuId;
          setUsuId(usuId);
          const nConsultor = await httpUsers(user.token, `listar/${usuId}`);
          setUsuNome(nConsultor && nConsultor[0].UsuNome);
        }
      } else {
        navigate("/login");
      }
    };
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const editando = location.state?.apontamento;
    //console.log(editando);
    if (editando && editando) {
      setApontamento(editando);
      setId(editando.ApoId);
      setUsuId(editando.fk_UsuId);
      setItemId(editando.fk_ItemId);
      //setValId(editando.fk_ValId);
      setApoData(editando.ApoData);
      setApoDatAtu(editando.ApoDatAtu);
      setHoras(editando.ApoQtdHoras);
      setStatus(editando.ApoStatus);
      setObs(editando.ApoObs);
      retValorHora(editando.ApoData, editando.fk_UsuId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const handleSave = async (e) => {
    e.preventDefault();
    const nApo = await validaCampos();

    if (nApo) {
      var endpoint = "inserir";
      if (nApo.ApoId > 0) {
        endpoint = `atualizar/${nApo.ApoId}`;
      }
      const data = await httpRequest(nApo, user.token, endpoint);
      console.log(data);
      if (data) {
        setApontamento(data);
        handleCancel();
      }
    }
  };
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Os meses começam em 0
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const retValorHora = async (apoData, usuId) => {
    const body = { ValDatIni: apoData };

    const valor = await httpValor(body, user.token, `ultimoValor/${usuId}`);
    if (valor && valor[0].ValId) {
      // setValId(await valor[0].ValId);
      setFormError(false);

      return valor[0].ValId;
    }
    setFormError(false);
    return false;
  };

  // valida os campos do formulário

  const validaCampos = async () => {
    if (!ApoQtdHoras || isNaN(parseFloat(ApoQtdHoras))) {
      setFormError("O campo Horas é obrigatório.");
      setHorasError(true);
      horRef.current.focus(); // Foca no campo Nome
      return false;
    }

    if (!ApoData) {
      setFormError("O campo Data é obrigatório.");
      setDataError(true);
      datRef.current.focus(); // Foca no campo data
      return false;
    }

    if (!ApoDatAtu) {
      setFormError("O campo Data é obrigatório.");
      setDatAtuError(true);
      datAtuRef.current.focus(); // Foca no campo data
      return false;
    }

    const valId = await retValorHora(ApoData, fk_UsuId);

    const nApontamento = {
      ApoId,
      fk_ItemId,
      fk_ValId: valId,
      fk_UsuId,
      ApoData,
      ApoDatAtu,
      ApoQtdHoras,
      ApoStatus,
      ApoObs
    };

    setApontamento(nApontamento);

    if (apontamento && apontamento) {
      return nApontamento;
    }
    return false;
  };

  const handleCancel = () => {
    setActive(false); // Desativa o botão "Cancelar"
    setId(0);
    //setValId(0);
    setApoData(0);
    setApoDatAtu(0);
    setHoras(0);
    setStatus(1);
    setObs("");
    // setValHora(0);
    handleCleanError();
    if (ApoId && ApoId) navigate("/registros");
    else navigate("/apontamentos");
  };
  const handleCleanError = () => {
    setFormError("");
    setError("");
  };

  const retornaStatus = () => {
    if (ApoStatus === 1) {
      return "Pendente";
    } else if (ApoStatus === 2) {
      return "Pago";
    } else if (ApoStatus === 3) {
      return "Confirmado";
    }
  };
  const decimalToTime = (decimal) => {
    if (decimal == null) return "";
    const hours = Math.floor(decimal); // Parte das horas
    const minutes = Math.floor((decimal - hours) * 60); // Parte dos minutos sem arredondar
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  const timeToDecimal = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    const horas = hours + minutes / 60;
    return horas;
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Apontamentos</h1>
      <div className={styles.card}>
        <Input
          label="Usuário"
          type="text"
          value={(UsuNome && UsuNome) || ""}
          disabled={true}
        />
        <Input
          label="Demanda"
          type="text"
          value={(ItemDes && ItemDes) || ""}
          disabled={true}
        />

        <Input
          ref={datRef} // Referência para o campo Nome
          label="Data apontamento"
          id="ApoData"
          type="date"
          value={(ApoData && ApoData) || ""}
          onChange={(e) => {
            setApoData(e.target.value);
            setApoDatAtu(e.target.value);
            setDataError(false);
            handleCleanError();
            setActive(true);
          }}
          hasError={dataError} // Aplica a classe de erro se houver erro no nome
        />

        <Input
          ref={datAtuRef} // Referência para o campo Nome
          label="Data atendimento"
          id="ApoDatAtu"
          type="date"
          value={(ApoDatAtu && ApoDatAtu) || ""}
          onChange={(e) => {
            setApoDatAtu(e.target.value);
            setDatAtuError(false);
            handleCleanError();
            setActive(true);
          }}
          hasError={datAtuError} // Aplica a classe de erro se houver erro no nome
        />
        <Input
          ref={horRef} // Referência para o campo Nome
          label="Horas"
          id="ApoQtdHoras"
          type="time"
          value={ApoQtdHoras != null ? decimalToTime(ApoQtdHoras) : ""} // Converte o valor decimal para o formato de hora
          onChange={(e) => {
            setHoras(timeToDecimal(e.target.value)); // Atualiza o valor em decimal no estado
            handleCleanError();
          }}
          hasError={horasError} // Aplica a classe de erro se houver erro no nome
        />
        <Input
          ref={obsRef} // Referência para o campo Nome
          label="Observações"
          id="ApoObs"
          type="text"
          value={(ApoObs && ApoObs) || ""}
          onChange={(e) => {
            setObs(e.target.value);
            setObsHasError(false);
            handleCleanError();
          }}
          hasError={obsHasError} // Aplica a classe de erro se houver erro no nome
        />
        <Input
          label="Status"
          type="text"
          value={retornaStatus()}
          disabled={true}
        />
        {loading && <p className={styles.loading}>Carregando...</p>}
        {formError && <p className={styles.error}>{formError}</p>}
        <Button texto="Salvar" onClick={handleSave} active={true} />
        <Button texto="Cancelar" onClick={handleCancel} active={true} />
      </div>
    </div>
  );
};

export default Registrar;
